import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex--align-center flex--gap-large" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "date-sort",
  class: "form__label form__label--filter"
}, " Sort by ", -1 /* HOISTED */)
const _hoisted_3 = { class: "flex flex--gap-small" }
const _hoisted_4 = { class: "datepicker-trigger__label" }
const _hoisted_5 = { class: "flex flex--align-center flex--gap-medium mb-16" }
const _hoisted_6 = ["for"]
const _hoisted_7 = ["id", "value"]
const _hoisted_8 = { class: "flex grid grid--xs flex--wrap" }
const _hoisted_9 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["Datepicker"], {
        "model-value": $setup.date.custom,
        "max-date": $setup.getToday,
        "time-config": { enableTimePicker: false },
        clearable: false,
        "auto-apply": "",
        range: "",
        "year-range": [2014, ( new Date() ).getFullYear()],
        config: { closeOnAutoApply: false },
        "onUpdate:modelValue": $setup.handleDatepickerSelect
      }, {
        "dp-input": _withCtx(({ isMenuOpen }) => [
          _createElementVNode("button", {
            class: _normalizeClass(["datepicker-trigger", { 'datepicker-trigger--expand': isMenuOpen }])
          }, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString($setup.display_value), 1 /* TEXT */)
            ])
          ], 2 /* CLASS */)
        ]),
        "top-extra": _withCtx(() => [
          _createCommentVNode(" Insert other filters here "),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sorting.options, (option) => {
              return (_openBlock(), _createElementBlock("label", {
                key: `sorting-${option.value}`,
                for: option.value,
                class: "form__radio form__radio--small form__radio--inline"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: option.value,
                  name: "sorting",
                  value: option.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.sorting.selected) = $event)),
                  onInput: $setup.handleSortingSelect
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7), [
                  [_vModelRadio, $setup.sorting.selected]
                ]),
                _createTextVNode(" " + _toDisplayString(option.label), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.date.options, (option, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `period-${option.value}`,
                class: _normalizeClass(["mb-8", i < 2 ? 'grid__item a6-12' : 'grid__item a4-12'])
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(["button button--smaller button--stretch button--squared", { 'button--selected': option.value === $setup.date.selected }]),
                  onClick: $event => ($setup.handlePeriodSelect( option.value ))
                }, _toDisplayString(option.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_9)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model-value", "year-range"])
    ])
  ]))
}